import { z } from 'zod';

type T = (key: string) => string;

export const createSubContainerTypeSchema = (t: T) =>
  z.object({
    name: z.string().min(1, t('subContainerTypeNameRequired')),
    container_type_id: z.string().min(1, t('subContainerTypeParentRequired')),
    status: z.enum(['active', 'inactive'])
  });

export const subContainerTypeSchema = createSubContainerTypeSchema((key) => {
  const defaults: Record<string, string> = {
    subContainerTypeNameRequired: 'Name is required.',
    subContainerTypeParentRequired: 'Parent container type is required.'
  };
  return defaults[key] ?? key;
});

export type SubContainerTypeFormValues = z.infer<typeof subContainerTypeSchema>;
